import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Menu,
  Checkbox,
  Table,
  Tag,
  Space,
  Radio,
  Divider,
  DatePicker,
  Result,
  Modal,
  InputNumber,
  notification,
  TimePicker,
} from 'antd'
import moment from 'moment'
const { RangePicker } = DatePicker
import { getCookie } from 'helper/cookie'
import {
  CarryOutOutlined,
  LeftOutlined,
  BellOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
  FastBackwardFilled,
  PauseCircleTwoTone,
} from '@ant-design/icons'
import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import 'styleLess/signature/sprintTaskFlow.scss'

import {
  addTaskInformation,
  getResultProjectList,
  postholiday,
  editTaskInformation,
  checkCompleteFlow,
  getFlowCheckDate,
} from 'api/Project/sprintFlow'

import lang from 'lang/en'

import {
  getMemberAssignee,
  getPermissionAssignee,
  editPermissionAssignee,
} from 'api/Project/sprintFlow'

const Container = styled.div`
  background-color: white;
  height: auto;
  margin-top: 32px;

  .border {
    border-radius: 5px;
  }

  .fontradio {
    font-family: IBMPlexSansThaiRegular;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    color: #000000;
  }
`
const format = 'HH:mm'

const initalState = {
  data: [],
  isLoading: true,
}
let taskDateStart = ''
let taskDateEnd = ''
const AddTaskInformaion = (props) => {
  // console.log(props)
  ///lang
  const language = getCookie('lang')
  const word = lang[language]
  // console.log(props.id)

  const {
    swithCaseTaskFLowFunction,
    idsubtask,
    role,
    idEditPRJ,
    GetName,
    checkPlandateTaskSubTask,
    checkChangeFlow,
    setCheckChangeFlow,
    fullyCheckComplete,
  } = props
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [form] = Form.useForm()

  // props.handleCancelModal(
  //   form.setFieldsValue({
  //     name: null,
  //     description: null,
  //     planned: null,
  //     workinghourperday: null,
  //     duration: null,
  //     totalworkinghour: null,
  //     workingday: null,
  //     tasktype: null,
  //     days: null,
  //     emailnotifi: null,
  //   }),
  // )

  /// holiday
  const [vishour, setVishour] = useState(true)
  const [plannedDateStart, setPlannedDateStart] = useState('')
  const [plannedDateEnd, setPlannedDateEnd] = useState('')
  const [dataHoliday, setDataHoliday] = useState(true)
  const [dataduration, setDataDuration] = useState()
  const [datatotalworkinghour, setDataTotalworkinghour] = useState()
  const [dataworkingday, setDataWorkingday] = useState()

  ///task
  const [saveapi, setSaveapi] = useState(true)
  const [dataSubTask, setDataSubTask] = useState(initalState.data)
  const [dataTask, setDataTask] = useState(initalState.data)
  const [idSubTask, setIDSubTask] = useState()

  ///email
  const [disableDays, setDisableDays] = useState(true)
  const [displayDays, setDisplayDays] = useState('none')

  //checkHavePlanstart
  const [checkHavePlanStart, setCheckHavePlanStart] = useState(false)

  const [disableDaysOndelay, setDisableDaysOndelay] = useState(true)
  const [displayDaysOndelay, setDisplayDaysOndelay] = useState('none')

  const [checkDisablePlanDate, setCheckDisablePlanDate] = useState(false)

  const [dataMember, setDataMember] = useState(initalState.data)

  //====================
  ///cal holiday
  function disabledDate(current) {
    // console.log(checkHavePlanStart)
    if (checkHavePlanStart == true) {
      return current && (current < moment(taskDateStart) || current > moment(taskDateEnd))
    } else {
      return (
        current &&
        (current < moment(taskDateStart) || current > moment(taskDateEnd).add(1, 'days'))
      )
    }
  }

  const onChangePlanned = (value, dateString) => {
    const start = dateString[0]
    const end = dateString[1]
    const workingHours = 8
    const durationDate = moment(end).diff(moment(start), 'days') + 1 // รวมวันเริ่มต้นด้วย
    const totalWorkingHourCal = `${durationDate * workingHours}:00`
    form.setFieldsValue({
      duration: durationDate,
      totalworkinghour: totalWorkingHourCal,
      workingday: durationDate,
      workinghourperday: moment(`08:00`, 'HH:m'),
    })
    setDataDuration(durationDate)
    setDataTotalworkinghour(totalWorkingHourCal)
    setDataWorkingday(durationDate)
    if (value == null) {
      setVishour(true)
    } else {
      setVishour(false)
    }
    setPlannedDateStart(dateString[0])
    setPlannedDateEnd(dateString[1])
    CheckChangePlanned(dateString[0], dateString[1])
  }

  const onChangeWorkperD = async (values) => {
    let hours = moment(values, '00:00').format('HH:mm')
    CheckChange(values, 'workinghourperday')

    if (hours == '00:00') {
      form.setFieldsValue({
        duration: null,
        totalworkinghour: null,
        workingday: null,
      })
    }

    const dataArray = {
      project_id: parseInt(idEditPRJ),
      plan_start: plannedDateStart,
      plan_end: plannedDateEnd,
      working_hour: hours,
    }
    try {
      await postholiday({
        params: dataArray,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        console.log(response)
        if (error) {
          setDataHoliday([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataHoliday(data)
          setIsLoading(false)

          form.setFieldsValue({
            duration: data.duration,
            totalworkinghour: data.working_hours,
            workingday: data.working_days,
          })
          setDataDuration(data.duration)
          setDataTotalworkinghour(data.working_hours)
          setDataWorkingday(data.working_days)
        } else {
          setDataHoliday([])
          setIsLoading(false)
          return true
        }
      })
    } catch (error) {
      setDataHoliday([])
      setIsLoading(false)
      console.log(error)
    }
  }

  ///task
  const getDataTask = async () => {
    await getResultProjectList({
      project_id: parseInt(idEditPRJ),
      id_chart: props.id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataTask([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          // setSaveapi(false)

          taskDateStart = data.plan_start
          taskDateEnd = data.plan_end
          await setDataTask(data)
          await setIsLoading(false)
        } else {
          setDataTask([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataTask([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getDataSubTask = async () => {
    await getResultProjectList({
      project_id: parseInt(idEditPRJ),
      id_chart: props.idsubtask,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataSubTask([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          // console.log(data)

          data.flow_status == 'In Progress'
            ? setCheckDisablePlanDate(true)
            : setCheckDisablePlanDate(false)
          getDataTask()
          setSaveapi(false)
          await setDataSubTask(data)
          await setIsLoading(false)
          form.setFieldsValue({
            name: data.title,
          })

          if (data.ondelay == 0) {
            form.setFieldsValue({
              OndelaysCheckBox: '',
            })
          } else {
            setDisplayDaysOndelay('')
            form.setFieldsValue({
              OndelaysCheckBox: [0],
              daysOndelay: data.ondelay,
            })
          }
          setIDSubTask(data.id)
          if (data.plan_start == '') {
            setCheckHavePlanStart(false)

            form.setFieldsValue({
              CommentsProds: 'Y',
            })

            form.setFieldsValue({
              // name: null,
              description: null,
              planned: null,
              workinghourperday: moment(`08:00`, 'HH:m'),
              duration: null,
              totalworkinghour: null,
              workingday: null,
              // tasktype: null,
              days: null,
              emailnotifi: null,
            })
            setVishour(true)
          } else {
            if (data.plan_start == '0000-00-00') {
              setPlannedDateStart(null)
              setPlannedDateEnd(null)
              form.setFieldsValue({
                planned: null,
              })
              setCheckHavePlanStart(false)
              setVishour(true)
            } else {
              setPlannedDateStart(data.plan_start)
              setPlannedDateEnd(data.plan_end)
              form.setFieldsValue({
                planned: [
                  moment(data.plan_start, 'YYYY-MM-DD'),
                  moment(data.plan_end, 'YYYY-MM-DD'),
                ],
              })
              setCheckHavePlanStart(true)
              setVishour(false)
            }
            setDataDuration(data.duration)
            setDataTotalworkinghour(data.total_working)

            setDataWorkingday(data.working)

            setIDSubTask(data.id)
            let a = data.email_noti.split(',')
            var result = a.map(function (x) {
              return parseInt(x, 10)
            })

            form.setFieldsValue({
              description: data.description,
              // planned: [
              //   moment(data.plan_start, 'YYYY-MM-DD'),
              //   moment(data.plan_end, 'YYYY-MM-DD'),
              // ],
              // workinghourperday: data.working_hour,
              duration: data.duration,
              totalworkinghour: data.total_working,
              workingday: data.working,
              CommentsProds: data.comment,

              emailnotifi: result,
            })
            if (data.working_hour == 0) {
              form.setFieldsValue({
                workinghourperday: null,
              })
            } else {
              form.setFieldsValue({
                workinghourperday: moment(`${data.working_hour}`, 'HH:m'),
              })
            }
            if (data.email_day == 0) {
              form.setFieldsValue({
                days: data.null,
              })
            } else {
              form.setFieldsValue({
                days: data.email_day,
              })
            }

            if (
              data.email_noti === '' ||
              data.email_noti === NaN ||
              data.email_noti === 'NaN'
            ) {
            } else {
              a.map((item) => {
                if (item == '4') {
                  setDisableDays(false)
                  setDisplayDays('')
                }
              })
            }
          }
        } else {
          setDataSubTask([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataSubTask([])
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getDataSubTask()
    }
  }, [token, props.idsubtask])
  const openNotificationWithIcon = (type) => {
    // console.log(dataPermission)

    notification[type]({
      message: 'Success',
      description: 'Information has been saved successfully.',
      duration: 3,
    })
  }

  const handleEditPermissionAssignee = (item) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: parseInt(props.idsubtask),
      account_id: item.account_id,
      permission: 5,
    }
    try {
      editPermissionAssignee({
        params: dataArray,
        token: token,
      }).then(async (response) => {
        const { status, data } = response
        if (status == 200) {
          return data
          // swithCaseTaskFLowFunction('')
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  // const getMemberData = async () => {
  //   await getMemberAssignee({
  //     sprintflow_id: parseInt(props.idsubtask),
  //     project_id: parseInt(idEditPRJ),
  //     token: token,
  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response
  //       if (error) {
  //         await setDataMember([])
  //         await setIsLoading(false)
  //         return true
  //       }
  //       if (status === 200) {
  //         if (data.member == null) {
  //           setDataMember([])
  //         } else {
  //           await setDataMember(data.member)
  //           data.member.map((item) => {
  //             if (item.permission == 0) {
  //               item.permission = 5
  //             }
  //             if (item.permission == 7) {
  //               handleEditPermissionAssignee(item)
  //             }
  //             if (item.role == 'Project Leader') {
  //               item.permission = 5
  //             }
  //             form.setFieldsValue({
  //               [item.firstname + item.role]: item.permission,
  //             })
  //           })
  //         }
  //         await setIsLoading(false)
  //       } else {
  //         setDataMember([])

  //         setIsLoading(false)
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       setDataMember([])
  //       setIsLoading(false)
  //       console.error(error)
  //     })
  // }

  // useEffect(() => {
  //   if (token) {
  //     getMemberData()
  //   }
  // }, [token])

  const onFinish = (values) => {
    // getMemberData()
    // console.log(values)
    if (values.emailnotifi == null) {
      values.emailnotifi = []
    }
    let emailnoti = values.emailnotifi.join(',')

    const dataArray = {
      id: parseInt(props.idsubtask),
      project_id: parseInt(idEditPRJ),
      title: values.name,
      id_chart: props.idchart,
      description: values.description,
      plan_start: plannedDateStart,
      plan_end: plannedDateEnd,
      duration: dataduration,
      working: dataworkingday,
      working_hour: moment(values.workinghourperday, '00:00').format('HH:mm'),
      total_working: datatotalworkinghour,
      email_noti: emailnoti,
      email_day: parseInt(values.days),
      task_type: 'O',
      level: 2,
      level_id: props.id,
      ondelay: parseInt(values.daysOndelay),
      comment: values.CommentsProds,
    }

    try {
      editTaskInformation({
        params: dataArray,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (status === 200) {
          GetName()
          checkPlandateTaskSubTask()
          props.setChangePageInformation(true)
          props.setChangePageInformation2(true)
          openNotificationWithIcon('success')
          props.getDataSubTask()
          // props.handleOkAddTask()

          getFlowCheckDate({
            project_id: parseInt(idEditPRJ),
            token: token,
          })
            .then(async (response) => {
              const { status, data, error } = response

              if (error) {
                setIsLoading(false)
                return true
              }

              let flowComplete = ''
              if (data.err_check == 'Y' || fullyCheckComplete == 'N') {
                // setVisibleModalCheckSubtask(true)
                setCheckChangeFlow('N')
                flowComplete = 'N'
              } else {
                setCheckChangeFlow('Y')
                flowComplete = 'Y'
              }

              const dataArray = {
                project_id: parseInt(idEditPRJ),
                complete_flow: flowComplete,
              }

              try {
                checkCompleteFlow({
                  params: dataArray,
                  token: token,
                }).then((response) => {
                  const { status, data, error } = response
                  if (status === 200) {
                    // getChartData()
                  }
                })
              } catch (error) {
                console.log(error)
              }

              if (status === 200) {
                setIsLoading(false)
              } else {
                setIsLoading(false)
                return true
              }
            })
            .catch((error) => {
              setIsLoading(false)
              console.error(error)
            })
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onChangeCheckBox = (e) => {
    if (e.target.checked == true) {
      CheckChange(e, 'beforeduedate')
      setDisableDays(false)
      setDisplayDays('')
    } else {
      CheckChange(e, 'beforeduedate2')
      form.setFieldsValue({
        days: null,
      })
      setDisableDays(true)
      setDisplayDays('none')
    }
  }

  const checkruledays = (values) => {
    if (values == false) {
      if (role == true) {
        return (
          <Form.Item name="days">
            <Input
              disabled
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
        )
      } else {
        return (
          <Form.Item
            name="days"
            rules={[
              {
                required: true,
                message: word['addsubtask_information_Email_Days'],
              },
            ]}
          >
            <Input
              disabled={disableDays}
              onChange={(e) => CheckChange(e, 'Days')}
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
        )
      }
    } else {
      if (role == true) {
        return (
          <Form.Item name="days">
            <Input
              disabled
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
        )
      } else {
        return (
          <Form.Item name="days">
            <Input
              disabled={disableDays}
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
        )
      }
    }
  }

  const onChangeCheckBoxOndelay = (e) => {
    if (e.target.checked == true) {
      CheckChange(e, 'Ondelay')
      setDisableDaysOndelay(false)
      setDisplayDaysOndelay('')
    } else {
      CheckChange(e, 'Ondelay2')
      form.setFieldsValue({
        daysOndelay: null,
      })
      setDisableDaysOndelay(true)
      setDisplayDaysOndelay('none')
    }
  }

  const checkruledaysOndelay = (values) => {
    if (role == true) {
      return (
        // <div style={{ display: displayDays }}>
        <Form.Item name="daysOndelay">
          <Input
            disabled
            type="number"
            className="border"
            placeholder="Days"
            size="large"
            min={1}
            style={{ width: 140 }}
          ></Input>
        </Form.Item>
        // </div>
      )
    } else {
      if (values == false) {
        return (
          // <div style={{ display: displayDays }}>
          <Form.Item
            name="daysOndelay"
            rules={[
              {
                required: true,
                message: word['addsubtask_information_ondelay_Days'],
              },
            ]}
          >
            <Input
              id="daysOndelay"
              disabled={disableDaysOndelay}
              onChange={(e) => CheckChange(e, 'OndelayDays')}
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
          // </div>
        )
      } else {
        return (
          // <div style={{ display: displayDays }}>
          <Form.Item name="daysOndelay">
            <Input
              type="number"
              onChange={(e) => CheckChange(e, 'OndelayDays')}
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
          // </div>
        )
      }
    }
  }

  const CheckChange = (e, type) => {
    if (type == 'Title') {
      if (dataSubTask.title !== e.target.value) {
        props.setChangePageInformation(false)
        // console.log('title change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'Description') {
      if (dataSubTask.description == undefined) {
        dataSubTask.description = ''
      }
      if (dataSubTask.description !== e.target.value) {
        props.setChangePageInformation(false)
        // console.log('description change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'workinghourperday') {
      if (dataSubTask.working_hour !== e) {
        props.setChangePageInformation(false)
        // console.log('workinghourperday change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'tasktype') {
      if (dataSubTask.task_type == '') {
        dataSubTask.task_type = 'O'
      }
      if (dataSubTask.task_type !== e.target.value) {
        props.setChangePageInformation(false)
        // console.log('tasktype change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'CommentsProds') {
      if (dataSubTask.comment == '') {
        dataSubTask.comment = 'Y'
      }
      if (dataSubTask.comment !== e.target.value) {
        props.setChangePageInformation(false)
        // console.log('CommentsProds change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'emailnotifi') {
      let a = dataSubTask.email_noti.split(',')
      var result = a.map(function (x) {
        return parseInt(x, 10)
      })
      if (result == 'NaN') {
        result = []
      }
      // console.log(result)
      // console.log(e)
      if (result.length == 4) {
        let checkemail = 0
        result.map((item) => {
          e.map((item2) => {
            if (item == item2) {
              checkemail = checkemail + 1
            }
          })
        })
        // console.log(checkemail, result.length)
        if (checkemail != result.length) {
          props.setChangePageInformation(false)
          // console.log('change checkbox email')
        } else {
          props.setChangePageInformation(true)
        }
      } else if (result.length == 0) {
        let checkemail = 0
        result.map((item) => {
          e.map((item2) => {
            if (item == item2) {
              checkemail = checkemail + 1
            }
          })
        })
        // console.log(result.length, e.length)
        if (e.length != result.length) {
          props.setChangePageInformation(false)
          // console.log('change checkbox email')
        } else {
          props.setChangePageInformation(true)
        }
      } else {
        // console.log('1-3')
        let checkemail = 0
        result.map((item) => {
          e.map((item2) => {
            // console.log(item, item2)
            if (item == item2) {
              checkemail = checkemail + 1
            }
          })
        })
        if (checkemail != result.length || e.length != result.length) {
          props.setChangePageInformation(false)
          // console.log('change checkbox email')
        } else {
          props.setChangePageInformation(true)
        }
      }
    } else if (type == 'Days') {
      if (dataSubTask.email_day == undefined) {
        dataSubTask.email_day = ''
      }

      if (dataSubTask.email_day != e.target.value) {
        props.setChangePageInformation(false)
        // console.log('Days change')
      } else {
        props.setChangePageInformation2(true)
        props.setChangePageInformation(true)
      }
    } else if (type == 'OndelaysCheckBox2') {
      let checkboxdefault = false
      if (dataSubTask.ondelay == 0) {
        checkboxdefault = false
      } else {
        checkboxdefault = true
      }

      let checkbox = false
      if (e.length == 0) {
        checkbox = false
      } else {
        checkbox = true
      }

      if (checkboxdefault != checkbox) {
        props.setChangePageInformation(false)
        // console.log('OndelaysCheckBox')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'OndelayDays') {
      // console.log(dataSubTask.ondelay, e.target.value)
      if (dataSubTask.ondelay != parseInt(e.target.value)) {
        props.setChangePageInformation(false)
        // console.log('Ondelay Days change')
      } else {
        props.setChangePageInformation2(true)
        props.setChangePageInformation(true)
      }
    } else if (type == 'Ondelay') {
      props.setChangePageInformation2(false)
      // console.log('change Ondelay')
    } else if (type == 'Ondelay2') {
      props.setChangePageInformation2(true)
    } else if (type == 'beforeduedate') {
      props.setChangePageInformation2(false)
      // console.log('change beforeduedate')
    } else if (type == 'beforeduedate2') {
      props.setChangePageInformation2(true)
    }
  }
  const CheckChangePlanned = (dateStart, dateEnd) => {
    if (dataSubTask.plan_start !== dateStart) {
      // console.log('planStart change')
      props.setChangePageInformation(false)
    } else if (dataSubTask.plan_end !== dateEnd) {
      // console.log('planEnd change')
      props.setChangePageInformation(false)
    } else {
      props.setChangePageInformation(true)
    }
  }

  return (
    <Container className="disable-page">
      <Form form={form} name="addtaskinformation" onFinish={onFinish}>
        <Row span={24}>
          <Col
            span={24}
            style={{
              // maxHeight: 400,
              // overflow: 'scroll',
              paddingRight: 29,
            }}
          >
            <Row>
              <Col span={24}>
                <h4 className="label">{word['addtask_information_title_name']}</h4>
                <Form.Item
                  name="name"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: word['addsubtask_information_Name'],
                    },
                  ]}
                >
                  <Input
                    disabled={role}
                    className="border"
                    onChange={(e) => CheckChange(e, 'Title')}
                    placeholder="Name"
                    size="large"
                  ></Input>
                </Form.Item>

                <h4 className="label">{word['addtask_information_title_deliverable']}</h4>
                <Form.Item name="description">
                  <Input
                    disabled={role}
                    onChange={(e) => CheckChange(e, 'Description')}
                    className="border"
                    placeholder="Enter Deliverable"
                    size="large"
                  ></Input>
                </Form.Item>
                <Row span={24}>
                  <Col span={12} style={{ paddingRight: 16 }}>
                    <h4 className="label">{word['addtask_information_title_planned']}</h4>
                    <Form.Item
                      name="planned"
                      rules={[
                        {
                          required: true,
                          message: word['addtask_information_Planned'],
                        },
                      ]}
                    >
                      <RangePicker
                        disabled={checkDisablePlanDate ? [true, false] : role}
                        disabledDate={disabledDate}
                        className="border"
                        style={{ width: '100%' }}
                        onChange={onChangePlanned}
                        format="YYYY-MM-DD"
                        size="large"
                      />
                    </Form.Item>

                    <h4 className="label">
                      {word['addtask_information_title_duration']}
                    </h4>
                    <Form.Item name="duration">
                      <Input
                        disabled={role}
                        className="border"
                        placeholder="Duration (Days)"
                        disabled
                        size="large"
                      ></Input>
                    </Form.Item>

                    <h4 className="label">
                      {word['addtask_information_title_totalworkinghour']}
                    </h4>
                    <Form.Item name="totalworkinghour">
                      <Input
                        disabled={role}
                        className="border"
                        placeholder="Total Working Hour"
                        disabled
                        size="large"
                      ></Input>
                    </Form.Item>
                    <p style={{ color: '#FFAF00', marginTop: -20, marginBottom: 20 }}>
                      {datatotalworkinghour == 0
                        ? '* Start/end date is holiday ,Working days equal to 0 days.'
                        : ''}
                    </p>
                  </Col>
                  <Col span={12} style={{ paddingLeft: 16 }}>
                    <h4 className="label">
                      {word['addtask_information_title_workinghourperday']}
                    </h4>
                    <Form.Item
                      name="workinghourperday"
                      rules={[
                        {
                          required: true,
                          message: word['addtask_information_Working_hours_per_day'],
                        },
                      ]}
                    >
                      {/* <Input
                        type="number"
                        className="border"
                        placeholder="Working hours per day"
                        disabled={role ? true : vishour}
                        min={1}
                        max={24}
                        onChange={(e) => onChangeWorkperD(e.target.value)}
                        size="large"
                        style={{ width: '100%' }}
                      ></Input> */}
                      <TimePicker
                        id="working_hours"
                        defaultValue={moment('08:00', 'HH:mm')}
                        placeholder="Working hours per day"
                        disabled={role ? true : vishour}
                        onOk={(e) => onChangeWorkperD(e)}
                        size="large"
                        style={{ width: '100%' }}
                        format={format}
                        showNow={false}
                        // onOk={onchangeTime}
                      />
                    </Form.Item>

                    <h4 className="label">
                      {word['addtask_information_title_workingday']}
                    </h4>
                    <Form.Item name="workingday">
                      <Input
                        className="border"
                        placeholder="Working day (Days) "
                        disabled
                        size="large"
                      ></Input>
                    </Form.Item>

                    {/* <h4 className="label">Task Type</h4>
                    <Form.Item
                      name="tasktype"
                      rules={[
                        {
                          required: true,
                          message: '* ',
                        },
                      ]}
                    >
                      <Radio.Group>
                        <Radio className="fontradio" value={'M'}>
                          Mandatory
                        </Radio>
                        <Radio className="fontradio" value={'O'}>
                          Optional
                        </Radio>
                      </Radio.Group>
                    </Form.Item> */}

                    <div style={{ marginLeft: -10 }}>
                      <h4 className="label">
                        {word['addtask_information_title_comments']}
                      </h4>
                      <Form.Item
                        name="CommentsProds"
                        onChange={(e) => CheckChange(e, 'CommentsProds')}
                        rules={[
                          {
                            required: true,
                            message: word['addtask_information_Comments/Prods'],
                          },
                        ]}
                      >
                        <Radio.Group disabled={role} id="Comments/Prods">
                          <Radio className="fontradio" value={'Y'}>
                            {word['addtask_information_value_comments_yes']}
                          </Radio>
                          <Radio className="fontradio" value={'N'}>
                            {word['addtask_information_value_comments_no']}
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Col
              span={24}
              style={{
                paddingLeft: 16,
                paddingRight: 16,
                paddingTop: 16,
                paddingBottom: 16,
              }}
            >
              <Row>
                <Col span={19} style={{ marginTop: 8 }}>
                  <Row>
                    <h2 className="colortextemail">
                      {word['addtask_information_title_emailnoti']}
                    </h2>
                  </Row>
                </Col>
              </Row>
              <Row style={{ marginTop: 24 }}>
                <Form.Item name="emailnotifi">
                  <Checkbox.Group
                    disabled={role}
                    style={{ display: 'flex', flexDirection: 'row' }}
                    onChange={(e) => CheckChange(e, 'emailnotifi')}
                  >
                    <Checkbox className="fontradio" value={1}>
                      {word['addtask_information_value_emailnoti_start']}
                    </Checkbox>
                    <div style={{ marginLeft: 40 }}>
                      <Checkbox className="fontradio" value={2}>
                        {word['addtask_information_value_emailnoti_end']}
                      </Checkbox>
                    </div>
                    <div style={{ marginLeft: 40 }}>
                      <Checkbox className="fontradio" value={3}>
                        {word['addtask_information_value_emailnoti_update']}
                      </Checkbox>
                    </div>
                    <div style={{ marginLeft: 40 }}>
                      <Checkbox
                        className="fontradio"
                        value={4}
                        onChange={onChangeCheckBox}
                      >
                        {word['addtask_information_value_emailnoti_beforedue']}
                      </Checkbox>
                    </div>
                  </Checkbox.Group>
                </Form.Item>

                <Row style={{ marginTop: -9, marginLeft: 16, display: displayDays }}>
                  {checkruledays(disableDays)}
                  <div style={{ marginTop: 9, marginLeft: 16 }}>
                    <h4>{word['addtask_information_unit_beforedue']}</h4>
                  </div>
                </Row>
              </Row>

              <Row>
                <Form.Item name="OndelaysCheckBox">
                  <Checkbox.Group
                    disabled={role}
                    id="OndelaysCheckBox"
                    style={{ display: 'flex', flexDirection: 'row' }}
                    onChange={(e) => CheckChange(e, 'OndelaysCheckBox2')}
                  >
                    <Checkbox
                      value={0}
                      className="fontradio"
                      onChange={onChangeCheckBoxOndelay}
                    >
                      {word['addtask_information_value_emailnoti_delays']}
                    </Checkbox>
                  </Checkbox.Group>
                </Form.Item>

                <Row
                  style={{
                    marginTop: -9,
                    marginLeft: 16,
                    display: displayDaysOndelay,
                  }}
                >
                  {checkruledaysOndelay(disableDaysOndelay)}
                  <div
                    style={{
                      marginTop: 9,
                      marginLeft: 16,
                    }}
                  >
                    <h4>{word['addtask_information_unit_emailnoti_delays']}</h4>
                  </div>
                </Row>
              </Row>
            </Col>
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: 48 }}>
          {/* <Button
            className="BTN_Previous"
            style={{
              marginRight: 7,
            }}
            onClick={onCancelModal}
          >
            Cancel
          </Button> */}

          <Button className="BTN_Next" htmlType="submit">
            {word['addtask_information_btn_save']}
          </Button>
        </Row>
      </Form>
    </Container>
  )
}
export default AddTaskInformaion
